module.exports = __webpack_public_path__ + "ab8e47fa9f38b486932454f0b1c78c38.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-2.png
// module id = 2216
// module chunks = 0